
const SidebarFooter = () => {
    return (
        <div>

        </div>
    )
}

export {SidebarFooter}
